import { createStore } from 'vuex'
import createPersistedState from "vuex-persistedstate";

export const store = createStore({
  state: {
    code: null,
    state: null,
    g_smt_masking: null,
    maskDocomoId: null,
    name_kana: "",
    userinfo_flg: false,
    serviceType: null,
    service_select_flg:false, // お問い合わせ履歴からの画面遷移管理用
    logout_flg: false, // ナビバーの「ログアウト」表示管理用
    // 紛失・盗難情報
    model_name: "",
    lost_datetime: "",
    suspend_datetime: "",
    returned_datetime: "",
    model_change_datetime: "",
    restart_datetime: "",
    // 問合せ詳細画面への遷移用
    selected_enquiry_number: "",
    selected_serviceType: "",
  },
  getters: {
    code (state) {
      return state.code
    },
    state (state) {
      return state.state
    },
    g_smt_masking (state) {
      return state.g_smt_masking
    },
    maskDocomoId (state) {
      return state.maskDocomoId
    },
    userinfo_flg (state) {
      return state.userinfo_flg
    },
    serviceType (state) {
      return state.serviceType
    },
    service_select_flg (state) {
      return state.service_select_flg
    },
    logout_flg (state) {
      return state.logout_flg
    },
    model_name (state) {
      return state.model_name
    },
    lost_datetime (state) {
      return state.lost_datetime
    },
    suspend_datetime (state) {
      return state.suspend_datetime
    },
    returned_datetime (state) {
      return state.returned_datetime
    },
    model_change_datetime (state) {
      return state.model_change_datetime
    },
    restart_datetime (state) {
      return state.restart_datetime
    },
    selected_enquiry_number (state) {
      return state.selected_enquiry_number
    },
    selected_serviceType (state) {
      return state.selected_serviceType
    },
    name_kana (state) {
      return state.name_kana
    },
  },
  mutations: {
    updateVariable(state, authData){
      state.code = authData.code;
      state.state = authData.state;
      state.g_smt_masking = authData.g_smt_masking;
    },
    resetVariable(state){
      state.code = null
      state.state = null
      state.g_smt_masking = null
      state.serviceType = null
      state.service_select_flg = false
      state.userinfo_flg = false
      state.logout_flg = false
      state.name_kana = ""
    },
    updateUserinfoFlg(state, userinfo_flg){
      state.userinfo_flg = userinfo_flg
    },
    updateServiceType(state, serviceType){
      state.serviceType = serviceType
    },
    updateServiceSelectFlg(state, service_select_flg){
      state.service_select_flg = service_select_flg
    },
    updateLogoutFlg(state, logout_flg){
      state.logout_flg = logout_flg
    },
    updateMaskDocomoId(state, maskdocomo_id){
      state.maskDocomoId = maskdocomo_id
    },
    updateNameKana(state, name_kana){
      state.name_kana = name_kana
    },
    updateLostInfo(state, lostInfo) {
      state.model_name = lostInfo.model_name
      state.lost_datetime = lostInfo.lost_datetime
      state.suspend_datetime = lostInfo.suspend_datetime
      state.returned_datetime = lostInfo.returned_datetime
      state.model_change_datetime = lostInfo.model_change_datetime
      state.restart_datetime = lostInfo.restart_datetime
    },
    updateDetailParam(state, detailParam) {
      state.selected_enquiry_number = detailParam.enquiry_number
      state.selected_serviceType = detailParam.service_type
    },
  },
  actions: {
    updateVariable (context, authData) {
      context.commit('updateVariable', authData);
    },
    resetVariable (context) {
      context.commit('resetVariable');
    },
    updateUserinfoFlg (context, userinfo_flg) {
      context.commit('updateUserinfoFlg', userinfo_flg);
    },
    updateServiceType (context, serviceType) {
      context.commit('updateServiceType', serviceType);
    },
    updateServiceSelectFlg (context, service_select_flg) {
      context.commit('updateServiceSelectFlg', service_select_flg);
    },
    updateLogoutFlg (context, logout_flg) {
      context.commit('updateLogoutFlg', logout_flg);
    },
    updateMaskDocomoId (context, maskdocomo_id) {
      context.commit('updateMaskDocomoId', maskdocomo_id);
    },
    updateNameKana (context, name_kana) {
      context.commit('updateNameKana', name_kana);
    },
    updateLostInfo ( context, lostInfo) {
      context.commit('updateLostInfo', lostInfo)
    },
    updateDetailParam(context, detailParam){
      context.commit('updateDetailParam', detailParam)
    }
  },
  modules: {
  },
  plugins: [createPersistedState({
    key: "u2m_consumer",
    storage: window.sessionStorage
  })]
})
